import { render, staticRenderFns } from "./AddDataSet.vue?vue&type=template&id=5c5f0c00&scoped=true"
import script from "./AddDataSet.vue?vue&type=script&lang=js"
export * from "./AddDataSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f0c00",
  null
  
)

export default component.exports